import * as React from 'react';
import { RadioGroup, RadioGroupItem } from '../../../ui/radio-group';
import { Label } from '../../../ui/label';
import { cn } from '../../../../lib/utils';

export interface ReportingRadioOption {
    label: string;
    value: string;
}

interface DocumentRadioGroupProps {
    options: ReportingRadioOption[];
    value?: string;
    onChange?: (value: string) => void;
    name?: string;
    className?: string;
    disabled?: boolean;
}

export function DocumentRadioGroup({
    options,
    value,
    onChange,
    name,
    className,
    disabled,
}: DocumentRadioGroupProps) {
    return (
        <RadioGroup
            value={value}
            onValueChange={onChange}
            disabled={disabled}
            className={cn('flex flex-col space-y-2', className)}
            name={name}
        >
            {options.map((option) => (
                <div key={option.value} className="flex items-center space-x-2">
                    <RadioGroupItem
                        value={option.value}
                        id={`${name}-${option.value}`}
                    />
                    <Label
                        htmlFor={`${name}-${option.value}`}
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                    >
                        {option.label}
                    </Label>
                </div>
            ))}
        </RadioGroup>
    );
}
